import IdentityVerification from "./identity-verification.page";

export default IdentityVerification;
